<div class="shared-datatable-frame">
  <ngx-datatable
    #table
    class="bootstrap core-bootstrap fixed-row shared-datatable"
    [class.shared-datatable--horizontal-scroll]="horizontalScroll"
    [class.shared-datatable--horizontal-affordance]="showHorizontalScrollAffordance()"
    [class.shared-datatable--vertical-affordance]="showVerticalScrollAffordance()"
    [rows]="sources.data"
    [columns]="columnsForDisplay"
    [columnMode]="mode"
    [rowHeight]="'auto'"
    [summaryRow]="enableSummary"
    [summaryPosition]="summaryPosition"
    [footerHeight]="
      showFooter && sources.data?.length > 0 && sources.total !== undefined
        ? sources.total / (sources.limit ?? limit) > 1
          ? 57
          : 42
        : 0
    "
    [scrollbarH]="horizontalScroll"
    [externalSorting]="externalSorting"
    [reorderable]="false"
    [swapColumns]="false"
    (sort)="onSortChange($event)"
    [loadingIndicator]="loading"
  >
    <!-- [summaryHeight]="'auto'" -->

    @if (showFooter) {
    <ngx-datatable-footer>
      @if (sources.data?.length > 0) {
      <ng-template ngx-datatable-footer-template>
        <div
          class="datatable-footer-custom justify-content-between flex-column flex-sm-row"
          [formGroup]="form"
        >
          <div
            class="d-flex align-items-center w-100 mb-75 mb-sm-0"
            [ngClass]="{
              'justify-content-end': sources.total < 10,
              'justify-content-between': sources.total > 10
            }"
          >
            <!-- <div class="d-flex align-items-center w-100 mb-75 mb-sm-0" [ngClass]="{'justify-content-end': !((sources.total / (sources.limit ?? limit)) > 1), 'justify-content-between': ((sources.total / (sources.limit ?? limit)) > 1) }"> -->
            <label
              class="d-flex align-items-center"
              [hidden]="sources.total < 10"
            >
              <!-- <label class="d-flex align-items-center" [hidden]="!((sources.total / (sources.limit ?? limit)) > 1)"> -->
              {{ "TABLE.SHOW" | translate }}
              <select
                class="form-control form-control-sm line-height-condensed datatable-footer-row-fetch mx-50"
                formControlName="limit"
              >
                @for (option of options; track option.value) {
                <option [value]="option.value">
                  {{ option.value }}
                </option>
                }
              </select>
              {{ "TABLE.ENTRIES" | translate }}
            </label>
            @if (sources.total !== undefined) {
            <span class="text-muted">
              {{ "TABLE.TOTAL_RESULT" | translate }} {{ sources.total }}
              {{ "TABLE.TOTAL_LIST" | translate }}
            </span>
            }
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <datatable-pager
              [pagerLeftArrowIcon]="'datatable-icon-left'"
              [pagerRightArrowIcon]="'datatable-icon-right'"
              [page]="sources.page"
              [size]="sources.limit ?? limit"
              [count]="sources.total"
              [hidden]="!(sources.total / (sources.limit ?? limit) > 1)"
              (change)="onPageChange($event)"
            ></datatable-pager>
          </div>
        </div>
      </ng-template>
      }
    </ngx-datatable-footer>
    }
  </ngx-datatable>

  @if (showVerticalScrollAffordance()) {
  <div
    class="shared-datatable-vertical-affordance"
    role="scrollbar"
    tabindex="0"
    aria-label="Vertical table scrollbar"
    aria-orientation="vertical"
    aria-valuemin="0"
    [attr.aria-controls]="bodyScrollId"
    [attr.aria-valuemax]="verticalScrollMax"
    [attr.aria-valuenow]="verticalScrollValue"
    [class.shared-datatable-scrollbar--dragging]="isScrollbarDragging('vertical')"
    [style.top.px]="verticalScrollRailTopPx"
    [style.height.px]="verticalScrollRailHeightPx"
    (pointerdown)="onScrollbarPointerDown($event, 'vertical')"
    (pointermove)="onScrollbarPointerMove($event)"
    (pointerup)="onScrollbarPointerEnd($event)"
    (pointercancel)="onScrollbarPointerEnd($event)"
    (keydown)="onScrollbarKeydown($event, 'vertical')"
  >
    <div
      class="shared-datatable-vertical-affordance-thumb"
      [style.height.%]="verticalScrollThumbHeightPercent"
      [style.transform]="verticalScrollThumbTransform()"
    ></div>
  </div>
  }
</div>

@if (showHorizontalScrollAffordance()) {
<div
  class="shared-datatable-horizontal-affordance"
  role="scrollbar"
  tabindex="0"
  aria-label="Horizontal table scrollbar"
  aria-orientation="horizontal"
  aria-valuemin="0"
  [attr.aria-controls]="bodyScrollId"
  [attr.aria-valuemax]="horizontalScrollMax"
  [attr.aria-valuenow]="horizontalScrollValue"
  [class.shared-datatable-scrollbar--dragging]="isScrollbarDragging('horizontal')"
  (pointerdown)="onScrollbarPointerDown($event, 'horizontal')"
  (pointermove)="onScrollbarPointerMove($event)"
  (pointerup)="onScrollbarPointerEnd($event)"
  (pointercancel)="onScrollbarPointerEnd($event)"
  (keydown)="onScrollbarKeydown($event, 'horizontal')"
>
  <div
    class="shared-datatable-horizontal-affordance-thumb"
    [style.width.%]="horizontalScrollThumbWidthPercent"
    [style.transform]="horizontalScrollThumbTransform()"
  ></div>
</div>
}

<ng-template #tableSummaryOrder let-row="row" let-value="value">
  {{ "TABLE.SUMMARY_TOTAL" | translate }}
</ng-template>

@if (shouldShowLoadingState()) {
<div class="shared-datatable-loading" role="status" aria-live="polite">
  <div class="shared-datatable-loading-bar" aria-hidden="true"></div>
  <div class="shared-datatable-loading-content">
    @for (row of loadingSkeletonRows; track row) {
    <div class="shared-datatable-loading-row">
      <span class="shared-datatable-skeleton shared-datatable-skeleton--index"></span>
      <span class="shared-datatable-skeleton shared-datatable-skeleton--short"></span>
      <span class="shared-datatable-skeleton shared-datatable-skeleton--medium"></span>
      <span class="shared-datatable-skeleton shared-datatable-skeleton--wide"></span>
      <span class="shared-datatable-skeleton shared-datatable-skeleton--badge"></span>
      <span class="shared-datatable-skeleton shared-datatable-skeleton--action"></span>
    </div>
    }
  </div>
  <span class="visually-hidden">กำลังโหลดข้อมูล</span>
</div>
}

@if (shouldShowEmptyRow()) {
<div class="custom-empty-row">
  {{ "TABLE.NO_DATA_DISPLAY" | translate }}
</div>
}
